import React from 'react'
import { useState } from 'react';
import { AiFillDislike } from "react-icons/ai";
import { AiFillLike } from "react-icons/ai";
import { FaSave } from "react-icons/fa";




function Notification() {
    const [Customer, setCustomer] = useState(false);
    const [Notifyme, setNotifyme] = useState(false);
    const [NotifyCustomerviaSMS, setNotifyCustomerviaSMS] = useState(false);
    const [SendPasswordviaSMS, setSendPasswordviaSMS] = useState(false);
    const [WalletBalance, setwalletBalance] = useState(5);
    const [showvalidiation, setshowvalidation] = useState(false)


    const handleChange = (e) => {
        const value = e.target.value;

        if (value === "") {
            setwalletBalance("");
            setshowvalidation(true);
            return;
        }

        const numericValue = Number(value);
        setwalletBalance(numericValue);

        if (numericValue < 1 || numericValue > 100) {
            setshowvalidation(true);
        } else {
            setshowvalidation(false);
        }
    };

    return (
        <>
            <div>
                <div className='border-b-[1px] border-[#cfcdcd] pb-1  '>
                    <h1 className='text-[#000] font-semibold text-[14px] dark:text-[#fff]'>Settings tab
                    </h1>
                </div>
                <div className='w-[100%] flex justify-between'>
                    <div className='w-[48%] py-1'>
                        <div className='w-[100%] flex justify-between'>
                            <span className='text-[#121519] text-[12px] font-semibold dark:text-[#fff]'>Notify Customer via Email</span>
                            <div className='flex  items-center gap-3'>
                                <span
                                    onClick={() => {
                                        setCustomer(false)
                                    }}
                                    className='flex items-center text-red-600 text-[13px] cursor-pointer'><AiFillDislike /> No</span>
                                <button
                                    onClick={() => setCustomer(!Customer)}
                                    className={`w-[25px] h-[12px] flex items-center rounded-[50px] transition duration-300 ${Customer ? "bg-[#37715d]" : "bg-[#ef2323]"}`}>
                                    <div
                                        className={`bg-[#fff] w-[10px] h-[10px] rounded-full shadow-md transform transition ml-[1px] ${Customer ? "translate-x-[13px]" : ""}`}>
                                    </div>
                                </button>
                                <span
                                    onClick={() => {
                                        setCustomer(true)
                                    }}
                                    className='flex items-center text-[#37715d] text-[13px] cursor-pointer'><AiFillLike /> Yes</span>
                            </div>
                        </div>
                        <div className='w-[100%] flex justify-between mt-6'>
                            <span className='text-[#121519] text-[12px] font-semibold dark:text-[#fff]'>Notify ME via Email</span>
                            <div className='flex  items-center gap-3'>
                                <span
                                    onClick={() => {
                                        setNotifyme(false)
                                    }}
                                    className='flex items-center text-red-600 text-[13px] cursor-pointer'><AiFillDislike /> No</span>
                                <button
                                    onClick={() => setNotifyme(!Notifyme)}
                                    className={`w-[25px] h-[12px] flex items-center rounded-[50px] transition duration-300 ${Notifyme ? "bg-[#37715d]" : "bg-[#ef2323]"}`}>
                                    <div
                                        className={`bg-[#fff] w-[10px] h-[10px] rounded-full shadow-md transform transition ml-[1px] ${Notifyme ? "translate-x-[13px]" : ""}`}>
                                    </div>
                                </button>
                                <span
                                    onClick={() => {
                                        setNotifyme(true)
                                    }}
                                    className='flex items-center text-[#37715d] text-[13px] cursor-pointer'><AiFillLike /> Yes</span>
                            </div>
                        </div>
                        <div className='w-[100%] mt-6 flex flex-col'>
                            <span className='text-[#121519] text-[12px] font-semibold dark:text-[#fff]'>Default WalletBalance</span>
                            <input type="number"
                                value={WalletBalance}
                                onChange={handleChange}
                                className='w-[100%] border-[1px] border-[#cfcdcd] rounded-lg outline-none mt-2 text-[12px] py-1 px-1 font-semibold text-[#535252]'
                            />
                            {showvalidiation &&
                                <span className='text-[14px] text-red-600'>Please enter a value between 1 and 100 for default Wallet balance.</span>
                            }
                        </div>
                    </div>
                    <div className='w-[48%] py-1'>
                        <div className='w-[100%] flex justify-between'>
                            <span className='text-[#121519] text-[12px] font-semibold dark:text-[#fff]'>Notify Customer via SMS</span>
                            <div className='flex  items-center gap-3'>
                                <span
                                    onClick={() => {
                                        setNotifyCustomerviaSMS(false)
                                    }}
                                    className='flex items-center text-red-600 text-[13px] cursor-pointer'><AiFillDislike /> No</span>
                                <button
                                    onClick={() => setNotifyCustomerviaSMS(!NotifyCustomerviaSMS)}
                                    className={`w-[25px] h-[12px] flex items-center rounded-[50px] transition duration-300 ${NotifyCustomerviaSMS ? "bg-[#37715d]" : "bg-[#ef2323]"}`}>
                                    <div
                                        className={`bg-[#fff] w-[10px] h-[10px] rounded-full shadow-md transform transition ml-[1px] ${NotifyCustomerviaSMS ? "translate-x-[13px]" : ""}`}>
                                    </div>
                                </button>
                                <span
                                    onClick={() => {
                                        setNotifyCustomerviaSMS(true)
                                    }}
                                    className='flex items-center text-[#37715d] text-[13px] cursor-pointer'><AiFillLike /> Yes</span>
                            </div>
                        </div>
                        <div className='w-[100%] flex justify-between mt-6'>
                            <span className='text-[#121519] text-[12px] font-semibold dark:text-[#fff]'>Send Password via SMS</span>
                            <div className='flex  items-center gap-3'>
                                <span
                                    onClick={() => {
                                        setSendPasswordviaSMS(false)
                                    }}
                                    className='flex items-center text-red-600 text-[13px] cursor-pointer'><AiFillDislike /> No</span>
                                <button
                                    onClick={() => setSendPasswordviaSMS(!SendPasswordviaSMS)}
                                    className={`w-[25px] h-[12px] flex items-center rounded-[50px] transition duration-300 ${SendPasswordviaSMS ? "bg-[#37715d]" : "bg-[#ef2323]"}`}>
                                    <div
                                        className={`bg-[#fff] w-[10px] h-[10px] rounded-full shadow-md transform transition ml-[1px] ${SendPasswordviaSMS ? "translate-x-[13px]" : ""}`}>
                                    </div>
                                </button>
                                <span
                                    onClick={() => {
                                        setSendPasswordviaSMS(true)
                                    }}
                                    className='flex items-center text-[#37715d] text-[13px] cursor-pointer'><AiFillLike /> Yes</span>
                            </div>
                        </div>
                        <div className='w-[100%] mt-6 flex flex-col'>
                            <span className='text-[#121519] text-[12px] font-semibold dark:text-[#fff]'>Default Validity :</span>
                            <select 
                             className='w-[100%] border-[1px] border-[#cfcdcd] rounded-lg outline-none mt-2 text-[12px] py-1 px-1 font-semibold text-[#535252]'
                            >
                                    <option>Select Month</option>
                                    <option value="1" selected="">1 Month</option>
                                    <option value="2">2 Months</option>
                                    <option value="3">3 Months</option>
                                    <option value="4">4 Months</option>
                                    <option value="5">5 Months</option>
                                    <option value="6">6 Months</option>
                                    <option value="7">7 Months</option>
                                    <option value="8">8 Months</option>
                                    <option value="9">9 Months</option>
                                    <option value="10">10 Months</option>
                                    <option value="11">11 Months</option>
                                    <option value="12">1 Year</option>
                                    <option value="24">2 Years</option>
                                    <option value="36">3 Years</option>
                                    <option value="300">Unlimited</option>
                                </select>
                        </div>
                    </div>
                </div>
                <button className='border-[1px] border-[#3f7fca] text-[#3f7fca] hover:bg-[#3f7fca] hover:text-[#fff] flex items-center text-[12px] p-2 font-semibold rounded-lg gap-1 mt-4'><FaSave />
                                    Save</button>
            </div>
        </>
    )
}

export default Notification
